module.exports = __webpack_public_path__ + "static/media/SWSCRC1-32.2424c260.mp3";